import React from 'react';
import { Pressable, View, Text, Image, TextStyle, ViewStyle, ImageStyle } from 'react-native';
import defaultStyles from './DefaultBadgeButton.jss';

interface DefaultBadgeButtonProps {
    onPress: () => void;
    iconSource: { uri: string };
    title?: string;
    style?: {
        icon?: ImageStyle;
        button?: ViewStyle;
        textContainer?: ViewStyle;
        text?: TextStyle;
        iconContainer?: ViewStyle;
    };
    isDisabled?: boolean;
    activeOpacity?: number;
}

export const DefaultBadgeButton = ({
    onPress,
    iconSource,
    title = '',
    style,
    isDisabled = false,
    activeOpacity = 0.4,
}: DefaultBadgeButtonProps): React.ReactElement => (
    <Pressable
        disabled={isDisabled}
        onPress={onPress}
        style={({ pressed }) => [
            {
                backgroundColor: 'gray',
                opacity: pressed ? activeOpacity : 1,
            },
            defaultStyles.button,
            defaultStyles.secondaryButtonStyle,
            style?.button
        ]}
    >
        <View style={defaultStyles.iconContainer}>
            <Image source={iconSource} style={[defaultStyles.icon, style?.icon]} />
        </View>
        <View
            style={[
                iconSource ? defaultStyles.textContainer : defaultStyles.textContainerWithoutIcon,
                style?.textContainer
            ]}
        >
            <Text numberOfLines={1} style={[defaultStyles.mainText, style.text]}>
                {title}
            </Text>
        </View>
    </Pressable>
);